import { useQuery } from "react-query";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { getOfficeHierarchyChildByTypeId } from "../../../../actions/OfficeHierarchy";

export const useOfficeHierarchyChildByTypeId = (type, id) =>
  useQuery(
    ["OfficeHierarchyChild", type, id],
    () => getOfficeHierarchyChildByTypeId(type, id),
    { enabled: !!type && !!id, refetchOnWindowFocus: false }
  );
// const [officeHierarchy, setOfficeHierarchy] = useState([]);
// const { mutate } = useMutation((type,id) => getOfficeHierarchyByTypeId(type,id), {
//   onSuccess: (res) => {
//     // queryClient.invalidateQueries("GetOfficeHierarchyByTypeId");
//     setOfficeHierarchy(res);
//   },

// });

// return mutate;
